import { render, staticRenderFns } from "./HcRouterLink.vue?vue&type=template&id=056a1065&scoped=true&"
import script from "./HcRouterLink.vue?vue&type=script&lang=js&"
export * from "./HcRouterLink.vue?vue&type=script&lang=js&"
import style0 from "./HcRouterLink.vue?vue&type=style&index=0&id=056a1065&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a1065",
  null
  
)

export default component.exports